import React, { ReactNode, RefObject } from "react";
import { useNavigate } from "react-router-dom";

import { Grid, SxProps, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLogout } from "@src/api/user-auths/logout";
import { useDispatch } from "@src/store";
import { IgPageContentTopBar } from "@src/utils/IgPageContentTopBar";

const Root = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  paddingTop: theme.spacing(4),
  backgroundColor: theme.igBackgroundColors.baseLightMid,
  boxSizing: "border-box",
}));

interface IgPageContentProps {
  children: ReactNode;
  childrenSx?: SxProps;
  igPageContentRef?: RefObject<null>;
}

export const IgPageContent = (props: IgPageContentProps) => {
  const { children, igPageContentRef, childrenSx, ...rest } = props;
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logout = useLogout();

  return (
    <Root id={"ig-page-content"} {...rest}>
      <Grid
        rowSpacing={4}
        sx={{
          height: "100%",
          flexWrap: "nowrap",
          flex: 1,
          paddingX: 10,
        }}
        container
        direction={"column"}
      >
        <IgPageContentTopBar />

        <Grid
          ref={igPageContentRef}
          id={"ig-page-content-scrollable"}
          // mt={4}
          item
          sx={{
            flex: 1,
            // backgroundColor: theme.igBackgroundColors.baseLightMid,
            // borderRadius: "15px",
            // border: `1px solid ${theme.igBorders.core.default}`,
            // paddingY: 6,
            // paddingX: 10,
            // overflowY: "scroll",
            // overflowX: "hidden",
            ...childrenSx,
          }}
        >
          {children}
        </Grid>
      </Grid>
    </Root>
  );
};
